<form
  #form="ngForm"
  novalidate
>
  @let vm = offshoreReportStore.vm();

  <nsp-lat-long
    class="pt-2"
    name="position"
    id="position"
    title="Ship position"
    [required]="vm.isFieldRequired(tabId, sectionId, 'shipPosition')"
    [latLng]="positionAndWeatherStore.positionAndLogistics().position.value"
    [ngModel]="positionAndWeatherStore.positionAndLogistics().position.value"
  />
</form>
